import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";
import moment from "moment";
import React, { Fragment } from "react";
import { MinutesToHours } from "../../../../utils/MinutesToHours";
import { TypographyStyle } from ".";

const useStyles = makeStyles({
    rightAlignedCell: {
        textAlign: "right",
    },

    transactionOut: {
        color: "rgb(227, 107, 45)",
    },

    transactionIn: {
        color: "rgb(0, 43, 74)",
    },
});

const ClassesList = ({ record }) => {
    const classes = useStyles();

    const getDate = (time) => {
        if (time) {
            return moment.utc(time).format("DD MMM YYYY");
        } else {
            return "-";
        }
    };

    const getTime = (time) => {
        if (time) {
            return moment.utc(time).format("hh:mm A");
        } else {
            return "-";
        }
    };

    return record ? (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Date</TableCell>

                    <TableCell>Name of Class</TableCell>

                    <TableCell className={classes.rightAlignedCell}>
                        Time (Duration)
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {record.conductedSessions && record.conductedSessions.length
                    ? record.conductedSessions.map((session) => {
                          return (
                              <TableRow key={session._id}>
                                  <TableCell>
                                      {getDate(
                                          _.get(
                                              session,
                                              "configuration.session_start_time"
                                          )
                                      )}
                                  </TableCell>

                                  <TableCell>
                                      {_.get(session, "class_name", "-")}
                                  </TableCell>

                                  <TableCell
                                      className={classes.rightAlignedCell}
                                  >
                                      {`${getTime(
                                          _.get(
                                              session,
                                              "configuration.session_start_time"
                                          )
                                      )} GMT (${MinutesToHours(
                                          _.get(
                                              session,
                                              "configuration.session_duration",
                                              "-"
                                          )
                                      )})`}
                                  </TableCell>
                              </TableRow>
                          );
                      })
                    : null}
            </TableBody>
        </Table>
    ) : null;
};

export default ClassesList;
